import React, { useState } from "react";
import axios from "../../../../api/axios";
import Swal from "sweetalert2";

const Refuse = ({ complaintId, onActionCompleted }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const token = "Bearer " + localStorage.getItem("token")?.replace(/"/g, "");

  const sendTextValue = async (event) => {
    event.stopPropagation();

    if (!selectedOption) {
      setErrorMessage("Ju lutemi zgjedhni njërën nga arsyjet e refuzimit!");
      return;
    }

    try {
      await axios.post(
        "/api/complaints/refuse",
        { complaintId, rejectDescription: selectedOption },
        { headers: { Authorization: token, "Content-Type": "application/json" } }
      );

      Swal.fire({
        icon: "success",
        text: "Ankesa është refuzuar me sukses!",
        confirmButtonText: "Mbyll",
      });

      document.getElementById("my-modal-6").checked = false;
      onActionCompleted?.();
    } catch (err) {
      Swal.fire({
        icon: "error",
        text: "Diçka shkoi keq! Ju lutem provoni përsëri",
        confirmButtonText: "Mbyll",
      });
    }
  };

  return (
    <>
      <input type="checkbox" id="my-modal-6" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-5xl bg-white">
          <h3 className="flex justify-center pb-4 text-lg font-bold">
            Refuzim i raportit
          </h3>
          <select
            className="select select-bordered select-sm w-full bg-white"
            value={selectedOption}
            onChange={(e) => {
              setSelectedOption(e.target.value);
              setErrorMessage("");
            }}
          >
            <option value="" disabled>
              Zgjedhni arsyjen e refuzimit:
            </option>
            <option value="Raporti është refuzuar pasi nuk shihen të dhënat">
              Raporti është refuzuar pasi nuk shihen të dhënat
            </option>
            <option value="Raporti është refuzuar pasi nuk është i saktë">
              Raporti është refuzuar pasi nuk është i saktë
            </option>
          </select>

          {errorMessage && (
            <div className="text-red-500 mt-2">{errorMessage}</div>
          )}

          <footer className="modal-action">
            <label htmlFor="my-modal-6" className="btn">
              Kthehu
            </label>
            <button
              className="btn bg-red-500 text-white hover:bg-red-600"
              onClick={sendTextValue}
            >
              Refuzo
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Refuse;
